module.exports = __webpack_public_path__ + "static/img/shui-4.2d3b7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shui-4.png
// module id = UOuB
// module chunks = 0